import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import List from 'components/RevenueCenters/List'
import Pagination from 'components/Pagination'

import {
  getPaginatedRevenueCenters,
  getTotalRevenueCentersCount,
} from 'store/RevenueCenters/selector'
import { loadPaginatedAndFilteredRevenueCenters } from 'store/RevenueCenters/actions'
import { setQueryStringParameters } from 'store/AppState/actions'

const RevenueCenters = ({ queryStringParameters }) => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const paginatedRevenueCenters = useSelector(
    getPaginatedRevenueCenters
  )
  const totalRevenueCentersCount = useSelector(
    getTotalRevenueCentersCount
  )

  const handleChangeRowsPerPage = (event) => {
    handleLoadNewRevenueCenters({
      ...queryStringParameters,
      page: 1,
      per: Number(event.target.value),
    })
  }

  const handleClickPage = (page) => {
    handleLoadNewRevenueCenters({
      ...queryStringParameters,
      page: page,
    })
  }

  const handleLoadNewRevenueCenters = (data) => {
    dispatch(loadPaginatedAndFilteredRevenueCenters(data))
    dispatch(setQueryStringParameters(data, pathname))
  }

  return (
    <div className="items">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item -name-wrapper">Name</li>
          <li className="header__menu-item -image-wrapper">Image</li>
          <li className="header__menu-item -menus-status-wrapper">
            Menus Status
          </li>
        </ul>
      </div>
      <List allRevenueCenters={paginatedRevenueCenters} />
      <section className="footer">
        <Pagination
          totalItemsCount={totalRevenueCentersCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleClickPage={handleClickPage}
          pageNumber={queryStringParameters?.page}
          rowsPerPage={queryStringParameters?.per}
        />
      </section>
    </div>
  )
}

export default RevenueCenters
